import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, memo } from 'react';
import getComponentName from 'react-utils/getComponentName';
import refObject from '../utils/propTypes/refObject';
import { attachWrappedComponent } from './utils';
export default function (Component) {
  const ShareButtonComponent = /*#__PURE__*/memo(props => {
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      buttonRef: props.buttonRef || defaultRef
    }));
  });
  ShareButtonComponent.propTypes = Object.assign({}, Component.propTypes, {
    buttonRef: refObject
  });
  ShareButtonComponent.defaultProps = Component.defaultProps;
  ShareButtonComponent.displayName = `ShareButton(${getComponentName(Component)})`;
  attachWrappedComponent(ShareButtonComponent, Component);
  return ShareButtonComponent;
}